import React from 'react';
import LogoImagee from '../assets/images/image_two.png';
import favicon from '../assets/images/favicon.png';

const NikdipLogo = ({ width = "160", height = "60", className = "" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 80"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Water droplet shape */}
      <defs>
        <linearGradient id="waterGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1e3c72', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#2a5298', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="gearGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#ff6b35', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#e55a2b', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Logo image using foreignObject */}
      <foreignObject x="10" y="15" width="80" height="50">
        <img 
          // src={LogoImagee} 
          src={favicon} 
          alt="Nikdip Logo" 
          width="80" 
          height="50"
          style={{ objectFit: 'contain' }}
        />
      </foreignObject>
      
      {/* NIKDIP Text */}
      {/* <text
        x="55"
        y="35"
        fontFamily="'Inter', sans-serif"
        fontSize="34"
        fontWeight="700"
        fill="#1e3c72"
      >
        NIKDIP
      </text> */}
      
      {/* Company Name */}
      <text
        x="80"
        y="54"
        fontFamily="'Inter', sans-serif"
        fontSize="35"
        fontWeight="700"
        fill="#1e3c72"
        textAnchor="start"
      >
        NIKDIP
      </text>
      
      {/* Company Description */}
      {/* <text
        x="100"
        y="50"
        fontFamily="'Inter', sans-serif"
        fontSize="10"
        fontWeight="400"
        fill="#666"
        letterSpacing="1"
        textAnchor="start"
      >
        Multinational Company
      </text> */}
    </svg>
  );
};

export default NikdipLogo;
